import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { ImportEmployeesResponse } from "@/types";

async function importEmployees(
  request: FormData
): Promise<ImportEmployeesResponse> {
  const response = await httpRequest.post<ImportEmployeesResponse>(
    "/employees/import",
    request,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export function useImportEmployeesMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: importEmployees,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["employees"] });
    },
  });
}